// extracted by mini-css-extract-plugin
export default {"container":"style_container__Y227d","card":"style_card__SSUUp"};